import * as React from 'react';
import { useMemo } from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { PreLoader } from './PreLoader';
import { useTranslation } from 'react-i18next';

const Wrapper = () => {
  return useMemo(() => <PreLoader />, []);
};

export const VideoAttributes = () => {
  const { t } = useTranslation();

  return (
    <>
      <DocumentHead title={t('Video Attributes')} />
      <PageTemplate main={<Wrapper />} />
    </>
  );
};
